<template>
  <div class='PCHomeView-container'>
    <div class="info-wrapper">
      <div class="bg2left"></div>
      <div class="bg1"></div>
      <div class="info-container">
        <div class="header">
          <div class="company-name">{{ company }}出品</div>
          <div class="f1"></div>
<!--          <div class="btn" @click="toPC">电脑版登录</div>-->
        </div>
        <div class="app-name">{{ appName }}</div>
        <div class="slogan">2025新规题库，让你驾考通关更轻松！</div>
        <div class="qrcode-container">
          <div class="qrcode">
            <qrcode-vue :value="downUrl" :size="210" level="H"></qrcode-vue>
          </div>
          <div style="display: flex;flex-direction: column">
            <div style="display: flex;">
              <div class="ios">
                <div class="icon"></div>
                <div class="title">iPhone</div>
              </div>
              <div class="android">
                <div class="icon"></div>
                <div class="title">Android</div>
              </div>
            </div>
            <div class="down-btn"></div>
          </div>
        </div>
        <div class="phone-image" v-if="phoneImage" :style="{backgroundImage: 'url('+phoneImage+')'}"></div>
      </div>
    </div>
    <div class="footer">
      <div class="layout">
        <div class="logo-container" v-if="logo">
          <div class="icon" :style="{backgroundImage: 'url('+logo+')'}"></div>
          <div class="flex v">
            <div class="title">{{ appName }}APP</div>
            <div class="tips">简单易用，让你快速过考！</div>
          </div>
        </div>
        <div class="address">{{ address }}</div>
        <div class="icp" v-if="phone">联系电话：{{ phone }}</div>
        <div class="icp">© {{ host }} {{ company }} 版权所有 <a href="https://beian.miit.gov.cn/" target="_blank">{{ beian }}</a></div>
        <div class="icp" v-if="gonganCode"><img src="@/assets/gongan.png" class="gongan-icon"><a :href="'https://beian.mps.gov.cn/#/query/webSearch?code='+gonganCode" rel="noreferrer" target="_blank">{{gongan}}</a></div>
        <div class="qrcode-container kefu" v-if="kefu">
          <div class="qrcode" :style="{backgroundImage: 'url('+kefu+')'}"></div>
          <div class="title">老师微信</div>
        </div>
        <div class="qrcode-container xcx" v-if="xcx">
          <div class="qrcode" :style="{backgroundImage: 'url('+xcx+')'}"></div>
          <div class="title">{{ appName }}小程序</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'PCHomeView',
  components: {
    QrcodeVue
  },
  data () {
    return {
      downUrl: '',
      beian: '',
      host: '',
      phone: '',
      appName: '驾校考试通',
      company: '北京青文科技有限公司',
      phoneImage: 'ui3.jpg',
      address: '北京市海淀区丰慧中路7号新材料创业大厦10层10层北侧办公1456号',
      logo: 'logo3.png',
      kef: null,
      gongan: null,
      gonganCode: null,
      xcx: null
      // kefu: 'http://down.qwdata.vip/guanwang/pc/kefu_qrcode.png',
      // xcx: 'http://down.qwdata.vip/guanwang/pc/xiaochengxu_qrcode.png'
    }
  },
  mounted () {
    this.downUrl = location.href
    if (this.$route) {

    }

    console.log('this.$route', this.$route)

    if (location.host.indexOf('jiaxiaokaoshitong.com') > -1) {
      this.beian = '京ICP备19027719号-4'
      this.host = 'jiaxiaokaoshitong.com'
      this.phoneImage = 'ui3.jpg'
      this.kefu = null
      this.xcx = null
    } else if (location.host.indexOf('jiakaosouti.com') > -1) {
      this.beian = '京ICP备19027719号-2'
      this.host = 'jiakaosouti.com'
      this.kefu = null
      this.xcx = null
    } else if (location.host.indexOf('jiakaoxintiku.com') > -1) {
      this.beian = '京ICP备19027719号-3'
      this.host = 'jiakaoxintiku.com'
      this.appName = '驾考一点全科通'
      this.phoneImage = '2.jpg'
      this.logo = 'logo4.png'
      this.kefu = null
      this.xcx = null
    } else if (location.host.indexOf('xinjiakao.cn') > -1) {
      this.beian = '京ICP备19027719号-14'
      this.host = 'xinjiakao.cn'
      this.appName = '驾考全科一点通'
      this.phoneImage = '1.png'
      this.logo = '1logo.png'
      this.kefu = null
      this.xcx = null
    } else if (location.host.indexOf('xiaokoudai.cn') > -1) {
      this.beian = '津ICP备2024012853号-1'
      this.host = 'xiaokoudai.cn'
      this.appName = '驾考全能王'
      this.phoneImage = '1.png'
      this.logo = 'logo_quannengwang.png'
      this.company = '天津小兜科技有限公司'
      this.address = '天津市静海区团泊镇橡树岛122-6'
      this.gongan = '津公网安备12022302000933号'
      this.gonganCode = '12022302000933'
      this.kefu = null
      this.xcx = null
    } else if (location.host.indexOf('h4321.com') > -1) {
      this.beian = '京ICP备2024063902号-1'
      this.host = 'h4321.com'
      this.appName = '驾考速通'
      this.phoneImage = '1.png'
      this.logo = 'logo3.png'
      this.company = '北京千秋通达科技有限公司'
      this.address = '北京市通州区张家湾镇北大化村116号9幢二层5755'
      this.kefu = null
      this.xcx = null
    } else {
      this.beian = '鄂ICP备2023005790号-1'
      this.host = 'lanmaojk.top'
      this.appName = '蓝猫驾考'
      // this.appName = '回隆驾校'
      this.phoneImage = '1.png'
      this.logo = 'logo3.png'
      this.company = '襄阳市回隆机动车驾驶员培训学校'
      this.address = '襄阳市樊城区振华路与松鹤路交叉路口'
      // this.phone = 13664140073
      // this.phone = 15701313531
      this.phone = 18210436011
      this.kefu = null
      this.xcx = null
    }
  },
  methods: {
    toPC () {
      window.open('http://xinjiakao.cn')
    }
  }
}
</script>

<style scoped lang='less'>
.PCHomeView-container {
  zoom: 80%;

  .info-wrapper {
    position: relative;
    background-color: #1559fe;

    .bg2left {
      position: absolute;
      left: 0;
      right: 50%;
      top: 0;
      bottom: 0;
      background-color: #0463f6;
    }

    .bg1 {
      background-image: url("/home-bg.png");
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
  }

  .info-container {
    height: 1022px;
    width: 1200px;
    padding-top: 1px;
    margin: 0 auto;
    position: relative;

    .phone-image {
      height: 783px;
      border-radius: 50px;
      width: 372px;
      position: absolute;
      z-index: 1;
      right: 10px;
      background-size: cover;
      bottom: 70px;
      background-color: #fff;
    }

    .header {
      margin-top: 40px;
      display: flex;
      width: 100%;
      color: #fff;
      .btn {
        font-size: 24px;
        cursor: pointer;
      }
    }

    .company-name {
      font-size: 24px;
    }

    .app-name {
      color: #fff;
      margin-top: 233px;
      font-size: 102px;
      font-weight: bold;
    }

    .slogan {
      color: #fff;
      margin-top: 46px;
      font-size: 40px;
    }

    .qrcode-container {
      margin-top: 87px;
      display: flex;

      .ios {
        flex: 1;
        color: #fff;
        font-size: 22px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .icon {
          width: 65px;
          height: 65px;
          margin-bottom: 20px;
          background-image: url("http://down.qwdata.vip/guanwang/pc/iphone.png");
        }
      }

      .android {
        flex: 1;
        color: #fff;
        font-size: 22px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .icon {
          width: 65px;
          height: 65px;
          margin-bottom: 20px;
          background-image: url("http://down.qwdata.vip/guanwang/pc/anzhuo.png");
        }
      }

      .down-btn {
        width: 373px;
        height: 90px;
        margin-top: 40px;
        background-image: url("http://down.qwdata.vip/guanwang/pc/saoma@1x.png");
      }

      .qrcode {
        width: 243px;
        height: 243px;
        background-color: #fff;
        border-radius: 15px;
        margin-right: 38px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .footer {
    height: 472px;
    background-color: #f7f7f7;

    .layout {
      width: 1200px;
      padding-top: 1px;
      margin: 0 auto;
      position: relative;
    }

    .qrcode-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: absolute;
      top: 100px;

      .qrcode {
        width: 170px;
        height: 170px;
      }

      .title {
        font-size: 24px;
        margin-top: 35px;
      }

      &.kefu {
        right: 250px;
      }

      &.xcx {
        right: 0;
      }
    }

    .address {
      margin-top: 62px;
      color: #373737;
      font-size: 19px;
    }

    .icp {
      margin-top: 30px;
      color: #373737;
      font-size: 19px;
    }

    .logo-container {
      display: flex;
      margin-top: 82px;

      .icon {
        width: 116px;
        height: 116px;
        margin-right: 28px;
        background-size: cover;
        border-radius: 30px;
      }

      .title {
        font-size: 36px;
        color: #202020;
        margin-bottom: 20px;
        margin-top: 10px;
      }

      .tips {
        font-size: 26px;
        color: #838383;
      }
    }
  }

  .gongan-icon {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
}
</style>
